

import { useEffect, useState, useMemo, useCallback } from 'react';
import {
  Breadcrumb,
  Button,
  Col,
  Form,
  Input,
  Row,
  Select,
  message,
  Table,
  Space,
  Tooltip,
  Typography,
  Spin,
  Modal
} from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { ReactComponent as Back } from '../../Images/Back.svg';
import { Option } from 'antd/es/mentions';
import TextArea from 'antd/es/input/TextArea';
import {
  createBundleOutWard,
  fetchBundleOutwardById,
  fetchBundleOutWardListByItem,
  finalizeBundleOutward,
  resetBundleOutWardList,
  fetchWorkOrderItemById,
  resetWorkOrderList,
} from '../../slices/warehouse-bundle-outward';
import { fetchVehicleList, resetVehicleList } from '../../slices/vehicle';
import { useDispatch, useSelector } from 'react-redux';
import { ReactComponent as EditIcon } from '../../Images/EditIcon.svg';
import dayjs from 'dayjs';
import debounce from 'lodash/debounce';

export default function FinalizeBundleOutward() {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const { id, outward_id } = useParams();
  const [search, setSearch] = useState('');
  const [orderBy, setOrderBy] = useState('');
  const [workOrderItem, setWorkOrderItem] = useState([]);
  const [page, setPage] = useState(1);
  const [pagesize, setPageSize] = useState(20);
  const { list: workOrderList = [], status } = useSelector(
    state => state.warehouseBundleOutward,
  );
  const [btnLoading, setBtnLoading] = useState(false);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [bundleOutwardId, setBundleOutwardId] = useState(null);
  const [disableCheck, setDisableCheck] = useState(false);
  const [vehicleSearchValue, setVehicleSearchValue] = useState('');
    const [vehicleHasMore, setVehicleHasMore] = useState([]);
    const [vehicleFetching, setVehicleFetching] = useState(false);
    const { list: vehicleList = [], status: vehicleStatus } = useSelector(state => state.vehicle);

  console.log("params id", id);
  console.log("params outward_id", outward_id);
  const rowSelection = {
    selectedRowKeys,
    onChange: selectedRowKeys => {
      setSelectedRowKeys(selectedRowKeys);
      setDisableCheck(selectedRowKeys.length !== 0);
    },
    getCheckboxProps: record => ({
      disabled: record.added_bundles === 0, // Disable row selection when added_bundles is 0
    }),
  };
  const [selectedWorkOrder, setSelectedWorkOrder] = useState(null);
  const [selectedWorkOrderId, setSelectedWorkOrderId] = useState(null);
  const [selectedWorkOrderBundles, setSelectedWorkOrderBundles] = useState([]);
  const [isSuccess, setIsSuccess] = useState(false);
  const navigate = useNavigate();
  const fetchBundleOutward = async () => {
    try {
      const response = await dispatch(
        fetchBundleOutwardById({ outward_id }),
      ).unwrap();

      if (response?.data) {
        const outwardData = response.data;

        form.setFieldsValue({
          workorder: outwardData.workorder?.order_no,
          shift: outwardData.shift || null,
          transporter_name: outwardData.transporter_name || null,
          vehicle_no: outwardData.vehicle_no,
          dispatch_to: outwardData.dispatch_to,
          remarks: outwardData.remarks || '',
        });

        getBundleOutwardList(outwardData.workorder?.id, outward_id);

        setBundleOutwardId(outwardData.id);
        setIsSuccess(true);
      }
    } catch (error) {
      console.error('Error fetching bundle outward:', error);
    }
  };

  useEffect(() => {
    fetchBundleOutward();
  }, [id, form, dispatch, fetchBundleOutwardById]);

  useEffect(() => {
    dispatch(resetWorkOrderList());
    dispatch(resetBundleOutWardList());

    return () => {
      dispatch(resetWorkOrderList());
      dispatch(resetBundleOutWardList());
    };
  }, [dispatch, search, orderBy]);


  const getBundleOutwardList = async (workOrderId, bundleOutwardId) => {
    try {
      const response = await dispatch(
        fetchBundleOutWardListByItem({
          page: 1,
          pagesize: 1000,
          workOrderId,
          bundleOutwardId,
        }),
      ).unwrap();

      const transformedData = response?.results?.data.map((item, index) => ({
        ...item,
        SrNo: index + 1,
        key: item.workorder_detail_id, // Ensure each row has a unique key
        disabled: item.added_bundles === 0, // Add disabled flag for selection logic
      }));
      setSelectedWorkOrderBundles(transformedData);
    } catch (error) {
      console.error('Error fetching bundle outward list:', error);
      setSelectedWorkOrderBundles([]);
    }
  };
  const handleFinalizeBundle = () => {
    const values = {
      workorder_detail_id: selectedRowKeys,
      warehouse_outward_id: Number(outward_id),
    };
    console.log(values);
    console.log(selectedWorkOrderBundles);
    const selectedIds = values?.workorder_detail_id || [];

    // find bundles having added bundles > 0 AND not included in request payload
    const unselectedAddedBundles = selectedWorkOrderBundles?.filter(
      (item) => item.added_bundles > 0 && !selectedIds.includes(item.key)
    );

    if (unselectedAddedBundles.length > 0) {
      Modal.warning({
        title: "Added Bundles Items Not Selected",
        width: 700,
        content: (
          <div style={{ maxHeight: "300px", overflowY: "auto", paddingRight: "10px" }}>
            <p>
              Please select following items to finalize bundle for added bundles.
              Otherwise restore these bundles and then finalize.
            </p>

            <ul style={{ paddingTop: 20 }}>
              {unselectedAddedBundles.map((item, index) => (
                <li
                  key={item.key}
                  style={{
                    marginTop: index === 0 ? 0 : 10,
                    lineHeight: "22px",
                  }}
                >
                  <b>{index + 1}.</b> {item.item_description}{" "}
                  (Added Bundles: {item.added_bundles}).
                </li>
              ))}
            </ul>
          </div>
        ),
      });
      return;
    }
    dispatch(finalizeBundleOutward({ values }))
      .unwrap()
      .then(result => {
        if (result?.success) {
          setBtnLoading(false);
          fetchBundleOutward();
          setSelectedRowKeys([]);
          message.success(result?.message);
          navigate("/warehouse-bundle-outward");
        }
      })
      .catch(error => {
        setBtnLoading(false);
        if (typeof error === 'object' && error !== null) {
          const messages = [];
          for (const key in error) {
            if (Array.isArray(error[key])) {
              messages.push(`${key}: ${error[key].join(', ')}`);
            }
          }
          if (messages.length > 0) {
            message.error(messages.join('; '));
          } else {
            message.error('An unknown error occurred.');
          }
        } else {
          message.error(
            typeof error === 'string' ? error : 'An unknown error occurred.',
          );
        }
      });
  };
  const handleFinish = async values => {
    setBtnLoading(true);
    dispatch(createBundleOutWard({ values }))
      .unwrap()
      .then(result => {
        setBtnLoading(false);
        message.success('Bundle OutWard Created Successfully!');
        setBundleOutwardId(result?.data?.id);
        setIsSuccess(true);
        getBundleOutwardList(values?.workorder, result?.data?.id);
      })
      .catch(error => {
        setBtnLoading(false);
        if (typeof error === 'object' && error !== null) {
          const messages = [];
          for (const key in error) {
            if (Array.isArray(error[key])) {
              messages.push(`${key}: ${error[key].join(', ')}`);
            }
          }
          if (messages.length > 0) {
            message.error(messages.join('; '));
          } else {
            message.error('An unknown error occurred.');
          }
        } else {
          message.error(
            typeof error === 'string' ? error : 'An unknown error occurred.',
          );
        }
      });
  };

  const handleTableChange = (pagination, filters, sorter) => {
    setPageSize(pagination.pageSize);
  };
  const handleAdd = data => {
    navigate(
      `/add-warehouse-bundle-for-outward/${data.workorder_detail_id}/${bundleOutwardId}`,
    );
  };
  const handlePartyPrint = data => {
    window.open(`/party-print-for-add-bundle-outward/${outward_id}`);
  };
  const handlePrint = outward_id => {
    window.open(`/warehouse-print-draft-bundle-outword/${outward_id}`);
  };

  const columns = [
    {
      title: 'Sr. No.',
      dataIndex: 'SrNo',
      key: 'SrNo',
      width: '80px',
    },
    {
      title: 'Item Description',
      dataIndex: 'item_description',
      key: 'workorder_die_number',
      width: '350px',
      render: (_, record) => record.item_description,
    },
    {
      title: 'Total Bundles',
      dataIndex: 'total_bundle',
      key: 'total_bundle',
    },

    {
      title: 'Total Pieces',
      dataIndex: 'total_piece',
      key: 'total_piece',
    },
    {
      title: 'Total Weight(kg)',
      dataIndex: 'total_weight',
      key: 'total_weight',
      sorter: true,
    },
    {
      title: 'Added Bundles',
      dataIndex: 'added_bundles',
      key: 'added_bundles',
    },
    {
      title: 'Added Pieces',
      dataIndex: 'added_bundles_pieces',
      key: 'added_bundles_pieces',
    },

    {
      title: 'Added Weight(kg)',
      dataIndex: 'added_bundles_weight',
      key: 'added_bundles_weight',
      sorter: true,
    },
    {
      title: 'Ready Bundles',
      dataIndex: 'ready_bundles',
      key: 'ready_bundles',
    },
    {
      title: 'Ready Pieces',
      dataIndex: 'ready_bundles_pieces',
      key: 'ready_bundles_pieces',
    },

    {
      title: 'Ready Weight(kg)',
      dataIndex: 'ready_bundles_weight',
      key: 'ready_bundles_weight',
      sorter: true,
    },
    {
      title: 'Status',
      dataIndex: 'status',
      width: '200px',
      key: 'status',
    },
    {
      title: 'Action',
      dataIndex: 'action',
      key: 'action',
      render: (_, record) => (
        <Space size="middle">
          {record.added_bundles === 0 ? (
            < Tooltip placement="top" title={'Add Bundle For OutWard'}>
              <span onClick={() => handleAdd(record)}>
                <PlusOutlined style={{ cursor: 'pointer' }} />
              </span>
            </Tooltip>
          ) : (
            < Tooltip placement="top" title={'Add Bundle For OutWard'} >
              <span onClick={() => handleAdd(record)}>
                <EditIcon style={{ cursor: 'pointer' }} />
              </span>
            </Tooltip >
          )}
        </Space>
      ),
    },
  ];
  const handleWorkOrderSelect = async workOrderId => {
    setWorkOrderItem([]);
    setSelectedWorkOrderBundles([]);

    const selectedWorkOrder = workOrderList.find(wo => wo.id === workOrderId);
    setSelectedWorkOrder(selectedWorkOrder);
    form.setFieldsValue({
      workorder_detail: [],
      remarks: null,
      transporter_name: null,
      dispatch_to: 'Warehouse',
      shift: null,
      vehicle_no: null,
    });
    setIsSuccess(false);
    try {
      const response = await dispatch(
        fetchWorkOrderItemById({
          id: workOrderId,
          page: 1,
          pagesize: 10,
          search: '',
          ordering: '',
        }),
      );
      const uniqueItems = Array.from(
        new Set(response.payload.map(item => item.id)),
      ).map(id => response.payload.find(item => item.id === id));

      setWorkOrderItem(uniqueItems);
    } catch (error) {
      console.error('Error fetching work order items:', error);
      setWorkOrderItem([]);
    }
  };

  const handleWorkOrderSelectItem = async selectedId => {
    const selectedItem = workOrderItem.find(item => item.id === selectedId);
  };

  const workOrder = (
    <Form.Item
      name="workorder"
      label="Select Work Order"
      style={{ fontWeight: 900 }}
      rules={[{ required: true, message: 'Please select workorder' }]}
    >
      <Select
        placeholder="Order No - Order Date - PO Number - PO Date - Customer Name"
        onChange={handleWorkOrderSelect}
        showSearch
        optionFilterProp="children"
        rules={[{ required: true, message: 'Please Select Work Order Item!' }]}
        style={{ width: '100%' }}
        disabled={true}
      >
        {workOrderList.map(wo => (
          <Option key={wo?.id} value={wo?.id}>
            {`${dayjs(wo?.order_date).format('DD/MM/YYYY')} - ${wo?.order_no} | ${wo?.purchase_order_no} - ${dayjs(wo?.purchase_order_date).format('DD/MM/YYYY')} | ${wo?.bill_to?.customer_name}`}
          </Option>
        ))}
      </Select>
    </Form.Item>
  );
  const workOrderFormItem = (
    <Form.Item name="workorder_detail" label="">
      <label className="clmlbl">Work Order Item</label>
      <Select
        placeholder="Select Work Order"
        onChange={handleWorkOrderSelectItem}
        showSearch
        optionFilterProp="children"
        rules={[{ required: true, message: 'Please Select Work Order!' }]}
        style={{ width: '100%' }}
      >
        {Array.isArray(workOrderItem) && workOrderItem.length > 0 ? (
          workOrderItem.map(wo => {
            return (
              <Option
                key={wo.id}
                value={wo.id}
                disabled={wo.bundle_out === false}
              >
                {`${wo.die_profile?.die_number || 'N/A'} - ${wo.length || 'N/A'} mm - 
        Packed: ${wo.packed_weight || '0.000'} kg - Dispatched: ${wo.dispatched || '0.000'} kg - 
        Net Order: ${wo.net_weight || '0.000'} kg - Temper: ${wo.temper?.name || 'N/A'} - 
        Code: ${wo.temper?.code || 'N/A'}`}
              </Option>
            );
          })
        ) : (
          <Option disabled>No items found</Option>
        )}
      </Select>
    </Form.Item>
  );

  const loadVehicleTypes = async (page) => {
        if (vehicleFetching || !vehicleHasMore) return;
    
        setVehicleFetching(true);
        const response = await dispatch(
          fetchVehicleList({
            page,
            pagesize: 20
          })
        );
        console.log(response?.payload);
        if (response?.payload?.next === null) {
          console.log("no more data");
          setVehicleHasMore(false);
        }
        setVehicleFetching(false);
      };
    
      const debouncedVehicleSearch = useMemo(() => debounce((value) => {
        setVehicleSearchValue(value);
        // setWorkOrderPage(1);
        setVehicleHasMore(true);
      }, 500), []); // 300ms delay for work order search
    
      const handleVehicleSearch = useCallback((value) => {
        setVehicleSearchValue(value);
        debouncedVehicleSearch(value);
      }, [debouncedVehicleSearch]);
    
      const handleVehicleDropdownScroll = (e) => {
        const { scrollTop, scrollHeight, clientHeight } = e.target;
        if (scrollHeight - scrollTop <= clientHeight + 10) {
          loadVehicleTypes(1);
        }
      };
    
      useEffect(() => {
        dispatch(resetVehicleList());
        loadVehicleTypes(1);
      }, []);
  return (
    <>
      <div className="sticyaction">
        <div className="sticky-header">
          <Row
            className="pagenamerow mb-3 "
            justify="space-between"
            align="middle"
          >
            <Col>
              <h2>Warehouse Bundle Outward Manage Items</h2>
              <div className="bredcrumbwrp">
                <Link className="back" onClick={(() => { navigate(-1) })}>
                  <Back /> BACK
                </Link>
                <Breadcrumb
                  items={[
                    { title: <Link to="/dashboard">Home</Link> },
                    { title: <Link to="/warehouse-bundle-outward">Warehouse Bundle OutWard</Link> },
                    { title: 'Warehouse Bundle Outward Manage Items' },
                  ]}
                />
              </div>
            </Col>
            <Col>
              <Space size="small">
                {/* <Link to="/add-warehouse-bundle-outward">
                  <Tooltip title="Add New Customer">
                    <Button type="primary" icon={<PlusOutlined />}>
                      Add Warehouse Bundle OutWard
                    </Button>
                  </Tooltip>
                </Link> */}
                <Link>
                  <Tooltip title="Finalize">
                    <Button
                      disabled={!disableCheck}
                      style={{ backgroundColor: '#e0f8e0' }}
                      onClick={() => handleFinalizeBundle()}
                    >
                      Finalize Outward
                    </Button>
                  </Tooltip>
                </Link>
                <Link>
                  <Tooltip title="Print Draft">
                    <Button
                      style={{ backgroundColor: '#FFFBF6' }}
                      onClick={() => handlePrint(outward_id)}
                    >
                      Print Draft Outward
                    </Button>
                  </Tooltip>
                </Link>
              </Space>
            </Col>
          </Row>
        </div>
      </div>
      <div className="formwrapper">
        <Form
          layout="vertical"
          autoComplete="off"
          form={form}
          onFinish={handleFinish}
          initialValues={{ dispatch_to: 'Warehouse' }}
        >
          <div className="formsection">
            <Row gutter={16}>
              <Col xs={24} sm={8} xl={6} xxl={4}>
                {workOrder}
              </Col>

              <Col xs={24} sm={8} xl={6} xxl={4}>
               <Form.Item
                              name="vehicle_no"
                              label="Vehicle Number"
                              rules={[{ required: true, message: 'Please Select Vehicle!' }]}
                            >
                              <Select
                                placeholder="Order Date - Order No - PO Number - PO Date - Customer Name"
                                onPopupScroll={handleVehicleDropdownScroll}
                                onSearch={handleVehicleSearch}
                                searchValue={vehicleSearchValue}
                                showSearch
                                filterOption={false}
                                style={{ width: '100%' }}
                                optionLabelProp="label"
                                notFoundContent={
                                  vehicleFetching || vehicleStatus !== 'succeeded' ? (
                                    <div style={{ textAlign: 'center' }}>
                                      <Spin size="small" />
                                    </div>
                                  ) : vehicleList.length === 0 ? (
                                    <div style={{ textAlign: 'center', padding: '8px' }}>
                                      No vehicle found
                                    </div>
                                  ) : null
                                }
                                loading={vehicleFetching || vehicleStatus !== 'succeeded'}
                              >
                                {vehicleList?.map(vh => (
                                  <Option key={vh.id} value={vh.id} label={vh.vehicle_no}>{vh?.vehicle_no}
                                  </Option>
                                ))}
                              </Select>
                            </Form.Item>
                {/* <Form.Item
                  name="vehicle_no"
                  label="Vehicle Number"
                  rules={[
                    {
                      pattern: /^[A-Za-z0-9 ]+$/,
                      message: 'Only letters, numbers, and spaces are allowed',
                    },
                  ]}
                >
                  <Input placeholder="Enter Vehicle Number" disabled />
                </Form.Item> */}
              </Col>

              <Col xs={24} sm={8} xl={6} xxl={4}>
                <Form.Item name="transporter_name" label="Transporter Name">
                  <Input placeholder="Enter Transporter Name" disabled />
                </Form.Item>
              </Col>

              <Col xs={24} sm={8} xl={6} xxl={4}>
                <Form.Item
                  name="shift"
                  label="Shift"
                  rules={[{ required: true, message: 'Please select shift' }]}
                >
                  <Select placeholder="Select Shift" disabled>
                    <Option value="A">A</Option>
                    <Option value="B">B</Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} sm={8} xl={6} xxl={4}>
                <Form.Item name="remarks" label="Remarks">
                  <TextArea placeholder="Enter Remarks" disabled />
                </Form.Item>
              </Col>
            </Row>
          </div>
        </Form>
        {isSuccess ? (
          <>
            <Typography.Title level={4} style={{ textAlign: 'center' }}>
              Work Order Items
            </Typography.Title>
            <Table
              rowKey="workorder_detail_id"
              rowSelection={rowSelection}
              columns={columns}
              dataSource={selectedWorkOrderBundles || []}
              pagination={{
                defaultCurrent: page,
                defaultPageSize: pagesize,
                showTotal: total => `Total ${total} items`,
                showSizeChanger: true,
              }}
              onChange={handleTableChange}
              pageSizeOptions={["20", "50", "100"]}
              loading={status === 'loading'}
              scroll={{ x: '600px' }}
            />
          </>
        ) : null}
      </div>
    </>
  );
}